/*
 * @Author: aalizzwell
 * @Date: 2019-08-02 15:31:34
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2020-03-03 09:33:43
 */
import { Injectable, Optional, Injector, ComponentFactoryResolver, ReflectiveInjector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RuntimeFrameworkService } from './rtf-service';
import { AppOptions, AppType } from '@gsp-sys/rtf-common';
import { MenuStateService } from './menu-state.service';
import { NavigationEventService } from './navigation-event.service';
import { QuerystringService } from './querystring';
import { FrameContext, TranslateToken, Translate, FrameComponent } from '@farris/devkit';
import { FEPageModalService } from '@farris/extend-page-modal';
import lodash from 'lodash-es';
import { FarrisFormService } from './farris-form.service';
import { LanguageService } from './languag.service';
import { map, switchMap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { FormNotifyService } from './form-notify.service';
import { INSIDE_DIALOG_TOKEN, MODAL_REF } from './types';
import { BsModalRef } from '@farris/ui-modal';
declare const System: any;
// tslint:disable: no-string-literal max-line-length
const APP_CONTEXT_MANAGER = 'DEVKIT_APP_CONTEXT_MANAGER';
/**
 * å¯¼èªæå¡
 * @scope FormModule
 */
@Injectable()
export class NavigationService {

  constructor(
    private runtimeFrameworkService: RuntimeFrameworkService,
    private menuStateService: MenuStateService,
    private navigationEventService: NavigationEventService,
    private querystringService: QuerystringService,
    @Optional() private frameContext: FrameContext,
    @Optional() private injector: Injector,
    @Optional() private languageService: LanguageService
    // @Optional() private pageModalService: FEPageModalService,
    // @Optional() private farrisFormService: FarrisFormService,
    // @Optional() private languageService: LanguageService
  ) {
    // appIdä¸åäºtabIdï¼æ¯æ¬¡è¡¨åå®ä¾åæ¶é½ä¼éæ°çæ
    const appId = this.formAppContext && this.formAppContext.ApplicationId;
    let tabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    // å·²ç»ç¼è¯çè¡¨åï¼ä½¿ç¨appIdè®°å½hash
    if (appId) {
      const appContextManager = window[APP_CONTEXT_MANAGER] || new Map<string, any>();
      if (appContextManager && !appContextManager.has(appId)) {
        appContextManager.set(appId, { hash: window.location.hash });
        window[APP_CONTEXT_MANAGER] = appContextManager;
      }
    }
    if (tabId) {
      const formEventServices: Map<string, any> = window['formEventServices'] || new Map<string, any>();
      // tabIdãappIdé½å­å¨æ¶ï¼ä½¿ç¨appIdæ¿æ¢tabId
      if (appId) {
        tabId = appId;
      }
      if (formEventServices && formEventServices.has(tabId)) {
        this.navigationEventService = formEventServices.get(tabId);
      } else {
        this.navigationEventService.registerEvent();
        formEventServices.set(tabId, this.navigationEventService);
        this.navigationEventService.frameContext = this.frameContext;
        window['formEventServices'] = formEventServices;
        this.registerDestroyEvent(tabId);
      }
    }
    if (!languageService) {
      this.languageService = new LanguageService();
    }
  }
  public set context(context) {
    this.navigationEventService['context'] = context;
    this['commandContext'] = context;
  }
  /**
   * è·åæ´ä¸ªè¡¨åçappcontextï¼é¤moduleä¸çappcontextï¼
   */
  private get formAppContext() {
    if (this.frameContext) {
      let appContext = this.frameContext.appContext;
      // tslint:disable-next-line: max-line-length
      while (appContext && appContext.parent && appContext.parent.injector && appContext.parent.injector.get(FrameContext, null) !== null) {
        appContext = appContext.parent;
      }
      return appContext;
    }
    return null;
  }
  private get querystrings() {
    let hash = window.location.hash;
    const appId = this.formAppContext && this.formAppContext.ApplicationId;
    if (appId) {
      const appContextManager = window[APP_CONTEXT_MANAGER];
      const appContext = appContextManager && appContextManager.get(appId);
      hash = appContext && appContext.hash || hash;
    }
    const params = this.querystringService.parse(hash);
    if (params) {
      params.formToken = this.runtimeFrameworkService.formToken;
    }
    return params;
  }
  /**
   * æç¤ºæå¡
   */
  private get formNotifyService() {
    return this.injector && this.injector.get<FormNotifyService>(FormNotifyService, null);
  }
  /**
   * æ³¨åéæ¯äºä»¶
   * @param tabId
   */
  private registerDestroyEvent(tabId: string) {
    if (this.frameContext && this.frameContext.destorySignal) {
      this.frameContext.destorySignal.subscribe(() => {
        this.navigationEventService = null;
      });
    }
    if (this.frameContext && this.frameContext.appContext && this.frameContext.appContext.destorySignal) {
      this.frameContext.appContext.destorySignal.subscribe(() => {
        const formEventServices = window['formEventServices'] as Map<string, any>;
        if (formEventServices) {
          formEventServices.delete(tabId);
        }
        const appContextManager = window[APP_CONTEXT_MANAGER] as Map<string, any>;
        if (appContextManager) {
          appContextManager.delete(tabId);
        }
      });
    }
  }
  // #region æ¥å£

  /**
   * æå¼èå
   * @param tabId æ ¹æ®TabIdå³å®æå¼æ°æ ç­¾é¡µæå®ä½ä¹åæå¼çæ ç­¾é¡µ
   * @param funcId èåId
   * @param params åæ°
   * @param reload æ¯å¦éæ°å·æ°
   * @param enableRefresh å¯ç¨æ°æ®å·æ°
   * @param tabName tabæ é¢
   * @param destructuring æ¯å¦è§£æåæ°
   */
  public openMenu(tabId: string, funcId: string, params: any, reload?: boolean, enableRefresh?: any, tabName?: string, destructuring?: any) {
    if (!funcId && this.formNotifyService) {
      this.formNotifyService.warning(this.languageService.appOrFuncIdRequired, { hideTitle: true });
      return EMPTY;
    }
    if (tabName) {
      tabName = this.translate(tabName);
    }

    let queryStringParams = this.buildParamMap(params);
    destructuring = this.convertToBoolean(destructuring, false);
    if (destructuring === true) {
      queryStringParams = this.buildParam(params);
    }
    // const paramsMap = this.buildParamMap(params);
    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    const options: AppOptions = {
      tabId,
      funcId,
      appType: AppType.Menu,
      queryStringParams: queryStringParams,
      entityParams: queryStringParams,
      appId: undefined,
      appEntrance: undefined,
      isReload: reload,
      tabName: tabName || null
    };
    // å¯ç¨æ°æ®å·æ°åæ°ä¸ºtrueæèæ²¡æå®ä¹ï¼åæå·æ°å¤ç
    // æ²¡æä¼ éè¯¥åæ°æè¯¥åæ°ä¸ºç©ºï¼åè®¤ä¸ºæç§ä¹åçé»è¾å¤çï¼é»è®¤å·æ°
    // null false "false" "true" undefined
    enableRefresh = this.convertToBoolean(enableRefresh, true);
    if (enableRefresh === true) {
      const frameworkTabId = tabId ? `${funcId}_${tabId}` : funcId;
      this.menuStateService.addMenuState(currentTabId, frameworkTabId);
    }
    this.runtimeFrameworkService.openMenu(options);
  }
  /**
   * æå¼èåï¼æµï¼
   * @param tabId æ ¹æ®TabIdå³å®æå¼æ°æ ç­¾é¡µæå®ä½ä¹åæå¼çæ ç­¾é¡µ
   * @param funcId èåId
   * @param params åæ°
   * @param reload æ¯å¦éæ°å·æ°
   * @param enableRefresh å¯ç¨æ°æ®å·æ°
   * @param destructuring è§£æåæ°
   */
  public openMenu$(tabId: string, funcId: string, params: any, reload?: boolean, enableRefresh?: any, tabName?: string, destructuring?: any) {
    if (!funcId && this.formNotifyService) {
      this.formNotifyService.warning(this.languageService.appOrFuncIdRequired, { hideTitle: true });
      return EMPTY;
    }
    if (tabName) {
      tabName = this.translate(tabName);
    }
    let queryStringParams = this.buildParamMap(params);
    destructuring = this.convertToBoolean(destructuring, false);
    if (destructuring === true) {
      queryStringParams = this.buildParam(params);
    }
    // const paramsMap = this.buildParamMap(params);
    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    const options: AppOptions = {
      tabId,
      funcId,
      appType: AppType.Menu,
      queryStringParams: queryStringParams,
      entityParams: queryStringParams,
      appId: undefined,
      appEntrance: undefined,
      isReload: reload,
      tabName: tabName || null
    };
    // å¯ç¨æ°æ®å·æ°åæ°ä¸ºtrueæèæ²¡æå®ä¹ï¼åæå·æ°å¤ç
    enableRefresh = this.convertToBoolean(enableRefresh, true);
    if (enableRefresh === true) {
      const frameworkTabId = tabId ? `${funcId}_${tabId}` : funcId;
      this.menuStateService.addMenuState(currentTabId, frameworkTabId);
    }
    return this.runtimeFrameworkService.openMenu$(options);
  }
  /**
   * æå¼èå(å¸¦ç»´åº¦)
   * @param tabId æ ¹æ®TabIdå³å®æå¼æ°æ ç­¾é¡µæå®ä½ä¹åæå¼çæ ç­¾é¡µ
   * @param funcId èåId
   * @param params åæ°
   * @param reload æ¯å¦éæ°å·æ°
   * @param enableRefresh å¯ç¨æ°æ®å·æ°
   * @param dim1 dim1
   * @param dim2 dim2
   * @param destructuring è§£æåæ°
   */
  public openMenuWithDimension(tabId: string, funcId: string, params: any, enableRefresh?: any, dim1?: any, dim2?: any, tabName?: string, metadataId?: string, destructuring?: any) {
    if (!funcId && this.formNotifyService) {
      this.formNotifyService.warning(this.languageService.appOrFuncIdRequired, { hideTitle: true });
      return EMPTY;
    }
    if (tabName) {
      tabName = this.translate(tabName);
    }
    if (metadataId === undefined || metadataId === null) {
      metadataId = '';
    }
    let queryStringParams = this.buildParamMap(params);
    destructuring = this.convertToBoolean(destructuring, false);
    if (destructuring === true) {
      queryStringParams = this.buildParam(params);
    }

    // const paramsMap = this.buildParamMap(params);
    queryStringParams.set('dim1', dim1 ? dim1 : 'public');
    queryStringParams.set('dim2', dim2 ? dim2 : 'public');
    queryStringParams.set('metadataId', metadataId);
    queryStringParams.set('isRtc', '1');
    queryStringParams.set('isRootMetadata', 'true');
    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    const options: AppOptions = {
      tabId,
      funcId,
      appType: AppType.Menu,
      queryStringParams: queryStringParams,
      entityParams: queryStringParams,
      appId: undefined,
      appEntrance: undefined,
      isReload: false,
      tabName: tabName || null
    };
    // å¯ç¨æ°æ®å·æ°åæ°ä¸ºtrueæèæ²¡æå®ä¹ï¼åæå·æ°å¤ç
    // æ²¡æä¼ éè¯¥åæ°æè¯¥åæ°ä¸ºç©ºï¼åè®¤ä¸ºæç§ä¹åçé»è¾å¤çï¼é»è®¤å·æ°
    // null false "false" "true" undefined
    enableRefresh = this.convertToBoolean(enableRefresh, true);
    if (enableRefresh === true) {
      const frameworkTabId = tabId ? `${funcId}_${tabId}` : funcId;
      this.menuStateService.addMenuState(currentTabId, frameworkTabId);
    }
    this.runtimeFrameworkService.openMenu(options);
  }
  /**
   * æå¼åºç¨
   * @param tabId tabId æ ¹æ®TabIdå³å®æå¼æ°æ ç­¾é¡µæå®ä½ä¹åæå¼çæ ç­¾é¡µ
   * @param appId åºç¨Id
   * @param appEntrance åºç¨å¥å£
   * @param params åæ°
   * @param reload æ¯å¦éæ°å·æ°
   * @param tabName tabæ é¢
   * @param enableRefresh å¯ç¨æ°æ®å·æ°
   * @param destructuring è§£æåæ°
   */

  public openApp(tabId: string, appId: string, appEntrance: string, params: any, reload?: boolean, tabName?: string, enableRefresh?: any, destructuring?: any) {
    if (!appId && this.formNotifyService) {
      this.formNotifyService.warning(this.languageService.appOrFuncIdRequired, { hideTitle: true });
      return EMPTY;
    }
    if (tabName) {
      tabName = this.translate(tabName);
    }
    let queryStringParams = this.buildParamMap(params);
    destructuring = this.convertToBoolean(destructuring, false);
    if (destructuring === true) {
      queryStringParams = this.buildParam(params);
    }
    // const paramsMap = this.buildParamMap(params);
    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    const options: AppOptions = {
      tabId,
      appId,
      appEntrance,
      funcId: undefined,
      appType: AppType.App,
      queryStringParams: queryStringParams,
      entityParams: queryStringParams,
      isReload: reload,
      tabName: tabName || null
    };
    enableRefresh = this.convertToBoolean(enableRefresh, true);
    if (enableRefresh === true) {
      const frameworkTabId = tabId ? `${appId}_${appEntrance}_${tabId}` : `${appId}_${appEntrance}`;
      this.menuStateService.addMenuState(currentTabId, frameworkTabId);
    }
    this.runtimeFrameworkService.openMenu(options);
  }
  /**
   * æå¼åºç¨(æµå¼)
   * @param tabId tabId æ ¹æ®TabIdå³å®æå¼æ°æ ç­¾é¡µæå®ä½ä¹åæå¼çæ ç­¾é¡µ
   * @param appId åºç¨Id
   * @param appEntrance åºç¨å¥å£
   * @param params åæ°
   * @param reload æ¯å¦éæ°å·æ°
   * @param tabName tabæ é¢
   * @param enableRefresh å¯ç¨æ°æ®å·æ°
   * @param destructuring è§£æåæ°
   */
  public openApp$(tabId: string, appId: string, appEntrance: string, params: any, reload?: boolean, tabName?: string, enableRefresh?: any, destructuring?: any) {
    if (!appId && this.formNotifyService) {
      this.formNotifyService.warning(this.languageService.appOrFuncIdRequired, { hideTitle: true });
      return EMPTY;
    }
    if (tabName) {
      tabName = this.translate(tabName);
    }
    let queryStringParams = this.buildParamMap(params);
    destructuring = this.convertToBoolean(destructuring, false);
    if (destructuring === true) {
      queryStringParams = this.buildParam(params);
    }
    // const paramsMap = this.buildParamMap(params);
    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    const options: AppOptions = {
      tabId,
      appId,
      appEntrance,
      funcId: undefined,
      appType: AppType.App,
      queryStringParams: queryStringParams,
      entityParams: queryStringParams,
      isReload: reload,
      tabName: tabName || null
    };
    enableRefresh = this.convertToBoolean(enableRefresh, true);
    if (enableRefresh === true) {
      const frameworkTabId = tabId ? `${appId}_${appEntrance}_${tabId}` : `${appId}_${appEntrance}`;
      this.menuStateService.addMenuState(currentTabId, frameworkTabId);
    }
    return this.runtimeFrameworkService.openMenu$(options);
  }
  /**
   * å³é­
   * @param onCloseing å³é­åäºä»¶å¤çå¨
   */
  public close() {
    const options = this.querystrings;
    const { isDialogComponent: isInDialog, rootComponent } = this.findDialog();
    if (isInDialog) {
      const modalRefFactory = this.get(rootComponent, 'dialogRef');
      let modalRef = null;
      if (typeof modalRefFactory === 'function') {
        const refs = modalRefFactory();
        modalRef = refs && refs.modalRef;
      } else {
        modalRef = modalRefFactory;
      }
      modalRef && modalRef['close']();
      return;
    }
    options.token = options.formToken;
    this.runtimeFrameworkService.beforeCloseMenu(options);
  }
  /**
   * å¼ºå¶å³é­
   */
  public destory() {
    const options = this.querystrings;
    options.token = options.formToken;
    this.runtimeFrameworkService.closeMenu(options);
  }
  /**
   *
   * @param params params
   * @deprecated å¾åºå¼ï¼ä¸buildParamMapéå¤
   */
  private parseParams(params: any) {
    if (typeof params === 'undefined' || params === null || (typeof params === 'string' && params.length < 1)) {
      params = {};
    }
    const paramMap = new Map<string, any>();
    if (typeof params === 'object') {
      params = JSON.stringify(params);
    }
    params = window['encodeURIComponent'](params);
    paramMap.set('WEB_FORM_ROUTE_PARAMS', params);
    return paramMap;
  }
  /**
   * æ³¨åäºä»¶çå¬å¨
   * @param eventType äºä»¶ç±»å onTabClosed
   * @param handler å¤çå¨
   * @returns string è¿åäºä»¶æ è¯
   */
  public addEventListener(eventType: string, handler: (options: AppOptions) => any): string {
    return this.navigationEventService.addEventListener(eventType, handler);
  }
  /**
   * ç§»é¤äºä»¶çå¬å¨
   * @param eventType äºä»¶ç±»å onTabClosed | onTabCloseing
   * @param key äºä»¶æ è¯
   */
  public removeEventListener(eventType: string, key: string): boolean {
    return this.navigationEventService.removeEventListener(eventType, key);
  }
  /**
   * æ¸ç©ºäºä»¶çå¬å¨
   * @param eventType äºä»¶ç±»å
   */
  public clearEventListener(eventType: string): void {
    this.navigationEventService.clearEventListener(eventType);
  }
  /**
   * ä»¥å¼¹æ¡ãä¾§è¾¹æ ææ°æ ç­¾é¡µæ¹å¼æå¼è¡¨å
   * @param mode æå¼æ¹å¼ï¼æ¯æ`modal`å¼¹çªã`sidebar`ä¾§è¾¹æ ã`tab`æ°æ ç­¾é¡µ
   * @param modalId å¼¹çªidï¼å¦æmode=`modal`ä¸æ²¡æurlï¼
   * @param configs å¼¹çªéç½®
   * @param url è¿ç«¯è¡¨åurl
   * @param tabId æ ç­¾é¡µidï¼modal=tabæ¶å¿å¡«
   * @param tabType æ ç­¾é¡µç±»åï¼`menu` æ`app`
   * @param funcOrAppId èåæåºç¨id
   * @param appEntrance åºç¨å¥å£
   * @param params åæ°
   * @param tabName æ°æ ç­¾é¡µåç§°
   * @param enableRefresh å¯ç¨å¯å¨å·æ°
   * @param destructuring æ¯å¦è§£æ
   */
  public open(mode: 'modal' | 'sidebar' | 'tab', modalId?: string, url?: string, configs?: any, tabId?: string, tabType?: 'menu' | 'app', funcOrAppId?: string, appEntrance?: string, params?: any, tabName?: string, enableRefresh?: any, destructuring?: any) {
    const pageModalService = this.injector.get<FEPageModalService>(FEPageModalService, null);
    if (!pageModalService) {
      throw new Error('get FEPageModalService failed.');
    }
    // æ ¡éªåæ°æ¯å¦åæ³
    if (!mode) {
      throw new Error('[NavigationService]->open,modeåæ°ä¸è½ä¸ºç©ºï¼');
    }
    if (mode === 'modal' || mode === 'sidebar') {
      if (!modalId && !url) {
        throw new Error('å¼¹çªåä¾§è¾¹æ æ¨¡å¼æ¶å¼¹çªå®¹å¨idåè¡¨åè·¯å¾ä¸è½åæ¶ä¸ºç©ºï¼');
      }
      if (modalId && url) {
        throw new Error('å¼¹çªåä¾§è¾¹æ æ¨¡å¼æ¶å¼¹çªå®¹å¨idåè¡¨åè·¯å¾ä¸è½åæ¶å­å¨ï¼');
      }
      const uiStateConfig = this.getObjectTypeConfig(params);
      const modalConfig = this.buildConfigs(configs);
      if (mode === 'sidebar') {
        modalConfig.dialogType = mode;
      }
      let pageModalRef = null;
      if (modalId) {
        const farrisFormService = this.injector.get<FarrisFormService>(FarrisFormService, null);
        if (!farrisFormService) {
          return;
        }
        const componentType = farrisFormService.getControls(modalId);
        const componentRef = this.createComponentRef(componentType, uiStateConfig);
        pageModalRef = pageModalService.show(componentRef, modalConfig);
      } else if (url) {
        pageModalRef = pageModalService.showByUrl(url, modalConfig);
      }
      if (pageModalRef && !!pageModalRef.content) {
        pageModalRef.content.isDialogRootComponent = true;
        pageModalRef.content.dialogRef = pageModalRef;
        const header = pageModalRef.dialog && pageModalRef.dialog.instance && pageModalRef.dialog.instance.el && pageModalRef.dialog.instance.el.nativeElement && pageModalRef.dialog.instance.el.nativeElement.querySelector(".f-page-header");
        if (header && pageModalRef.dialog.instance.draggbar) {
          pageModalRef.dialog.instance.draggbar.handle = header;
          header.style.cursor = 'move';
        }
      }
    } else if (mode === 'tab') {
      if (!tabId || !tabType || !funcOrAppId) {
        if (this.formNotifyService) {
          this.formNotifyService.warning(this.languageService.appOrFuncIdRequired, { hideTitle: true });
        }
        throw new Error('æ°æ ç­¾æ¨¡å¼æ¶æ ç­¾é¡µidãæ ç­¾ç±»åãèåæåºç¨idåä¸è½ä¸ºç©ºï¼');
      }
      if (tabType === 'app' && !appEntrance) {
        throw new Error('ä»¥åºç¨æ¹å¼æå¼æ¶å¥å£åºç¨ä¸è½ä¸ºç©ºï¼');
      }
      if (tabType == 'app') {
        this.openApp(tabId, funcOrAppId, appEntrance, params, false, tabName, enableRefresh, destructuring);
      } else if (tabType === 'menu') {
        this.openMenu(tabId, funcOrAppId, params, false, enableRefresh, tabName, destructuring);
      }
    } else {
      throw new Error('ä¸æ¯æçæ¨¡å¼ï¼');
    }
    // this.pageModalService.
  }
  /**
   * in app navigate
   * @param commands commands
   */
  // public navigate(commands: any[]);
  /**
   * in app navigate
   * @param commands commands
   * @param options options
   * @description options:{ relativeTo: this.activatedRoute, queryParams:{a:1,b:2},etc:...}
   */
  public navigate(commands: any[], options?: any): Promise<boolean> {
    const router = this.injector && this.injector.get<Router>(Router, null);
    const activatedRoute = this.injector && this.injector.get<ActivatedRoute>(ActivatedRoute, null);
    const queryParams = lodash.merge({}, this.querystrings, options && options.queryParams || {});
    if (options && options.hasOwnProperty('queryParams')) {
      delete options.queryParams;
    }
    const extras = lodash.merge({ skipLocationChange: false, relativeTo: activatedRoute, queryParams }, options || {});
    if (router) {
      return router.navigate(commands, extras);
    } else {
      return null;
    }
  }
  // #endregion

  // #region ç§ææ¹æ³

  /**
   * å°è£è·¯ç±åæ°
   * @param params åæ°
   * @param options éç½®åæ°
   */
  private buildParamMap(params: any, options?: any): Map<string, string> {
    if (typeof params === 'undefined' || params === null || (typeof params === 'string' && params.length < 1)) {
      params = {};
    }
    const paramMap = new Map<string, any>();
    if (options && Object.keys(options).length > 0) {
      if (typeof params !== 'object') {
        params = JSON.parse(params);
      }
      params = lodash.merge(params, options);
    }
    if (typeof params === 'object') {
      params = JSON.stringify(params);
    }
    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    params = window['encodeURIComponent'](params);
    paramMap.set('WEB_FORM_ROUTE_PARAMS', params);
    paramMap.set('WEB_FORM_ROUTER_PARENT_ID', currentTabId);
    return paramMap;
  }
  private buildParam(params, options?: any): Map<string, string> {
    if (typeof params === 'undefined' || params === null || (typeof params === 'string' && params.length < 1)) {
      params = {};
    }
    const paramMap = new Map<string, any>();
    if (options && Object.keys(options).length > 0) {
      if (typeof params !== 'object') {
        params = JSON.parse(params);
      }
      params = lodash.merge(params, options);
    }
    if (typeof params !== 'object') {
      params = JSON.parse(params);
    }
    Object.keys(params).forEach(key => {
      paramMap.set(key, params[key]);
    });

    const currentTabId = this.querystrings.tabId || this.querystrings.funcId || this.querystrings.appId;
    params = window['encodeURIComponent'](JSON.stringify(params));
    paramMap.set('WEB_FORM_ROUTE_PARAMS', params);
    paramMap.set('WEB_FORM_ROUTER_PARENT_ID', currentTabId);
    return paramMap;
  }
  /**
   * æ¥æ¾å¼¹çªç»ä»¶
   */
  private findDialog() {
    let frameContext = this.get(this, 'commandContext.frameContext');
    let isDialogComponent = this.get(frameContext, 'frameComponent.isDialogRootComponent', false);
    let rootComponent = null;
    let parentFrameContext = this.get(frameContext, 'parent');
    while (parentFrameContext != null && !isDialogComponent) {
      frameContext = this.get(frameContext, 'parent');
      parentFrameContext = this.get(parentFrameContext, 'parent');
      isDialogComponent = this.get(frameContext, 'frameComponent.isDialogRootComponent', false);
    }
    rootComponent = this.get(frameContext, 'frameComponent');
    if (!isDialogComponent) {
      isDialogComponent = this.frameContext.injector.get<boolean>(INSIDE_DIALOG_TOKEN, false);
      if (isDialogComponent) {
        const modalRef = this.frameContext.injector.get<BsModalRef>(MODAL_REF, null);
        rootComponent = { dialogRef: modalRef };
      }
    }
    return { isDialogComponent, rootComponent };
  }

  /**
   * loadsh get
   * @param object å¯¹è±¡
   * @param path è·¯å¾
   * @param defaultVal é»è®¤å¼
   */
  private get(object: any, path: Array<string> | string, defaultVal: any = null) {
    const PATH = Array.isArray(path)
      ? path
      : path.split('.').filter(i => i.length);
    if (!PATH.length) {
      return object === undefined ? defaultVal : object;
    }

    if (object === null || object === undefined || typeof (object[PATH[0]]) === 'undefined') {
      return defaultVal;
    }

    return this.get(object[PATH.shift()], PATH, defaultVal);
  }
  private convertToBoolean(value: any, defaultVal: boolean = false) {
    if (typeof value === 'undefined' || value === null) {
      value = defaultVal;
    }
    if (typeof value === 'string') {
      value = value || String(defaultVal);
      value = value === 'true' ? true : false;
    }
    return value;
  }
  /**
   * ç¿»è¯èµæºé¡¹
   * @param key èµæºé¡¹key
   */
  private translate(key: string) {
    const translateService = this.injector && this.injector.get<Translate>(TranslateToken, null) || null;
    if (translateService && key && key.startsWith('{{') && key.endsWith('}}')) {
      key = key.replace('{{', '').replace('}}', '').trim();
      return translateService.transform(key, null);
    }
    return key;
  }
  // #endregion

  //#region å¼¹çªç¸å³æ¹æ³
  private buildConfigs(config: any): { [prop: string]: any } {
    let languageService = this.injector.get<LanguageService>(LanguageService, null);
    if (!languageService) {
      languageService = LanguageService.getInstance();
    }

    const defaultConfigs: any = {
      title: languageService && languageService.defaultDialogTitle || '',
      width: 800,
      height: 500,
      showButtons: false
    };
    const objectTypeConfig = this.getObjectTypeConfig(config);
    const configs = Object.assign(defaultConfigs, objectTypeConfig);
    const onClosingHandler = configs.beforeClose;
    const refresh = configs['refresh'] || {};
    const refreshCommandName = refresh && refresh.commandName || null;
    const refreshFrameId = refresh && refresh.frameId || null;
    // tslint:disable: no-string-literal
    const cancelChanges = configs['cancelChanges'] || false;
    configs.beforeClose = (ref) => {
      if (!!onClosingHandler && typeof onClosingHandler === 'function') {
        return onClosingHandler(ref).pipe(
          switchMap(result => {
            if (result) {
              if (cancelChanges) {
                return this.cancelChanges(ref).pipe(
                  switchMap(() => this.refreshForm(refreshCommandName, refreshFrameId))
                );
              }
            }
            return of(result);
          })
        );
      } else {
        if (cancelChanges) {
          return this.cancelChanges(ref).pipe(
            switchMap(() => this.refreshForm(refreshCommandName, refreshFrameId))
          );
        } else {
          return of(true);
        }
      }

    };
    return configs;
  }
  private getObjectTypeConfig(config: any) {
    let objectTypeConfig: any
    if (typeof config === 'undefined') {
      config = {};
    }
    if (typeof config === 'string') {
      if (config.length) {
        try {
          objectTypeConfig = JSON.parse(config);
        } catch {
          throw new Error(config + 'ä¸æ¯åæ³çjsonå­ç¬¦ä¸²');
        }
      } else {
        objectTypeConfig = {};
      }
    } else if (typeof config === 'object') {
      objectTypeConfig = Object.assign({}, config);
    } else {
      throw new Error('å¡«åå¯¹è±¡æ ¼å¼æjsonå­ç¬¦ä¸²');
    }
    return objectTypeConfig;
  }
  /**
   * åæ¶æå¡å¨åæ´é
   */
  private cancelChanges(ref: any): Observable<boolean> {
    if (ref && ref.modalRef && ref.modalRef.content) {
      const component: FrameComponent = ref.modalRef.content as FrameComponent;
      if (component && component.context) {
        const repository = component.context.repository || null;
        if (repository) {
          return repository.cancelChanges().pipe(switchMap(() => of(true)));
        }
      }
    }
    return of(true);
  }
  private refreshForm(refreshCommandName: string, refreshFrameId: string): Observable<any> {
    if (refreshCommandName && refreshFrameId) {
      const frameContext = this.frameContext.appContext.frameContextManager.getFrameContextById(refreshFrameId);
      if (frameContext) {
        const viewModel = frameContext.viewModel;
        return viewModel[refreshCommandName]().pipe(
          map(() => true)
        );
      }
    }
    return of(true);
  }
  private createComponentRef(componentType: any, uiStateObject: any) {
    let componentRef: any;
    const frameContext = this.getFrameContext();
    const componentFactoryResolver = this.getComponentFactoryResolver();
    if (frameContext && componentFactoryResolver) {
      const contentCmptFactory = componentFactoryResolver.resolveComponentFactory(componentType);
      const modalContentInjector = ReflectiveInjector.resolveAndCreate([], frameContext.injector);
      componentRef = contentCmptFactory.create(modalContentInjector);
      if (componentRef && componentRef.instance && componentRef.instance.viewModel && componentRef.instance.viewModel.uiState) {
        if (typeof uiStateObject === 'object' && Object.keys(uiStateObject).length) {
          Object.keys(uiStateObject).forEach(item => {
            componentRef.instance.viewModel.uiState.setPropertyValue(item, uiStateObject[item]);
          });
        }
        // éå isDialogåæ°
        componentRef.instance.viewModel.uiState.setPropertyValue('DEVKIT_DIALOG', true);
      }
    }
    return componentRef;
  }
  /**
   * å¼å®¹æ§å¼¹çªï¼è·åframeContext
   */
  private getFrameContext() {
    if (this.frameContext) {
      return this.frameContext
    }
    if (this['context'] && this['context']['frameContext']) {
      return this['context']['frameContext'];
    }
    return null;
  }
  /**
   * å¼å®¹æ§å¼¹çªï¼è·åComponentFactoryResolver
   */
  private getComponentFactoryResolver() {
    const frameContext = this.getFrameContext();
    let componentFactoryResolver: any;
    if (frameContext) {
      componentFactoryResolver = frameContext.injector.get(ComponentFactoryResolver);
    }
    return componentFactoryResolver;
  }
  //#endregion
}
